//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import WholeBuildingItem from '@/components/business/whole_building_item'
import API from '@/service/whole_buildings'
import ExcellentConsultants from '@/components/business/_excellent_consultants'
import HomeService from '@/service/homepage'
import { handleImgSize } from '@/common/utils/map_view_data'
export default {
    data () {
        return {
            excellent_consultants: [],
            loading: true,
            items: []
        }
    },
    watch: {
        zone_ids (zone_ids) {
            console.error(zone_ids)
            if (zone_ids) {
                API.list({
                    zone_ids,
                    page: 1
                }).then((data) => {
                    this.items = data.items
                    this.loading = false
                })
            }
        }
    },
    components: {
        WholeBuildingItem,
        ExcellentConsultants
    },
    computed: {
        userHeadimgurl () {
            return this.headimgurl ? handleImgSize(this.headimgurl, 120, 120) : ''
        }
    },
    mounted() {
        this.getExcellentConsultant();
    },
    methods: {
        tapJoinGroup () {
            this.$sendCtmEvtLog('资格查询加群点击')
        },
        goStart (e) {
            this.$emit('goStart')
            this.loading = true
            this.items = []
        },
        getExcellentConsultant () {
            HomeService.getConsultants().then((data) => {
                this.excellent_consultants = data
            })
        },
        goConsultant () {
            this.$router.push({
                path:'/pages/consultants/main'
            })
        },
    },
    props: [ 'zone', 'questions', 'need', 'verify_type', 'headimgurl', 'zone_ids', 'need_result_tx']
}
